// "Jump back in" - the last few library books a student opened, shown on the
// start screen. Stored locally; respects incognito and the keep-history opt-out
// so it never persists when the user asked us not to.
import { readJSON, writeJSON, subscribe as storeSubscribe } from "../shared/store.js";
import { get } from "../shared/settings-store.js";

const KEY = "revault:book-recents";
const LIMIT = 12;

export function list() { const v = readJSON(KEY, []); return Array.isArray(v) ? v : []; }

export function record(book) {
	if (!book || !book.url) return;
	if (get("incognito") || get("keepHistory") === false) return; // honor privacy choices
	const items = list().filter((b) => b.url !== book.url);
	items.unshift({ id: book.id, name: book.name, cover: book.cover, thumb: book.thumb, url: book.url, ts: Date.now() });
	writeJSON(KEY, items.slice(0, LIMIT));
}

export function remove(url) { writeJSON(KEY, list().filter((b) => b.url !== url)); }
export function subscribe(fn) { return storeSubscribe(KEY, fn); }
